import { Component, computed, HostBinding, input, model } from '@angular/core';
import { ThemeColor } from '../helpers';

@Component({
  selector: 'app-pan-timepicker',
  templateUrl: './pan-timepicker.component.html',
  styleUrl: './pan-timepicker.component.scss',
  standalone: false,
})
export class PanTimepickerComponent {
  public color = input<ThemeColor>('default');
  public disabled = input<boolean>(false);
  public min = input<string>();
  public max = input<string>();
  public name = input<string>('');
  public placeholder = input<string>();
  public defaultValue = input<string>();
  public id = input<string>();

  public time = model<string | null>();

  @HostBinding('class')
  public get hostClasses() {
    return this.classes().join(' ');
  }

  public classes = computed(() => {
    return ['timepicker', `timepicker-color-${this.color()}`, this.disabled() ? 'timepicker-disabled' : ''].filter(Boolean);
  });
}
